module.exports = __webpack_public_path__ + "static/img_online_fieldtrip_banner_640-929d6561ce8c9ae6cbf3fb77ea0ff1b3.jpg";